import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App';
import { preloadPath } from './routes';
import './main.css';

const root = document.getElementById('root')!;

// Load the current route's chunk first so the first client render matches the
// prerendered markup exactly, then hydrate (never re-render) the existing DOM.
preloadPath(window.location.pathname).then(() => {
  if (root.firstElementChild) {
    hydrateRoot(root, <App />);
  } else {
    // Only in `npm run dev`, where index.html has no prerendered markup.
    createRoot(root).render(<App />);
  }
});
